<span [pTooltip]="tooltipValue" [tooltipStyleClass]="'w-auto'" [tooltipDisabled]="tooltipDisabled"
  tooltipPosition="bottom">
  <span *ngIf="isDateEnabled">
    {{value | customDate: 'shortDate'}}
  </span>
  <span *ngIf="isTimeEnabled" [ngClass]="{'text-light': !disableStyle }">
    {{value | customDate:'shortTime'}}
  </span>
</span>
